import React, { useMemo } from 'react';

import { Update } from 'src/shared/types/update';

import UpdateAnswerContent from './UpdateAnswerContent';
import UpdateReplyContent from './UpdateReplyContent';

interface TimelineItem {
  id: string;
  type: 'answer' | 'reply';
  timestamp: string;
  data: any;
}

interface UpdateThreadProps {
  update: Update;
}

const UpdateThread: React.FC<UpdateThreadProps> = ({ update }) => {
  const timelineItems = useMemo(() => {
    const items: TimelineItem[] = [];

    // Add answer if it exists
    if (update.question?.answer && update.question?.answered_at) {
      items.push({
        id: `answer-${update.question.id}`,
        type: 'answer',
        timestamp: update.question.answered_at,
        data: update.question
      });
    }

    // Add replies
    if (update.clarification?.replies) {
      update.clarification.replies.forEach((reply) => {
        items.push({
          id: `reply-${reply.id}`,
          type: 'reply',
          timestamp: reply.created_at,
          data: reply
        });
      });
    }

    // Sort by timestamp
    return items.sort(
      (a, b) =>
        new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
    );
  }, [update.question, update.clarification?.replies]);

  if (timelineItems.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col mt-2">
      {timelineItems.map((item, index) => {
        const isLast = index === timelineItems.length - 1;

        if (item.type === 'answer') {
          return <UpdateAnswerContent key={item.id} question={item.data} />;
        }

        return (
          <UpdateReplyContent key={item.id} reply={item.data} isLast={isLast} />
        );
      })}
    </div>
  );
};

export default UpdateThread;
